var map = {
	"./1.jpg": 6435,
	"./10.jpg": 8043,
	"./11.jpg": 7886,
	"./12.jpg": 9385,
	"./2.jpg": 6724,
	"./3.jpg": 8529,
	"./4.jpg": 3298,
	"./5.jpg": 5007,
	"./6.jpg": 7632,
	"./7.jpg": 2525,
	"./8.jpg": 7518,
	"./9.jpg": 1915
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1736;